import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { StateService } from '../../shared/services/state.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BusyService } from '../../shared/services/busy.service';
import { State } from '../../shared/models/State';
import { CountyService } from '../../shared/services/county.service';
import { County } from '../../shared/models/County';
import { OrgCategoryService } from '../../shared/services/org-category.service';
import { OrgCategory } from '../../shared/models/OrgCategory';
import { matchingPasswords } from '../../shared/validators/matchingPasswords';
import { numberValidator } from '../../shared/validators/numberValidator';
import { DistrictService } from '../../shared/services/district.service';
import { District } from '../../shared/models/District';
import { RegionService } from '../../shared/services/region.service';
import { Region } from '../../shared/models/Region';
import { HeadendService } from '../../shared/services/headend.service';
import { OrgHeadends } from '../../shared/models/OrgHeadends';
import { OrganizationService } from '../../shared/services/organization.service';
import { nullableEmailValidator } from '../../shared/validators/nullableEmailValidator';
import { AlertService } from '../../shared/services/alert.service';
import { FileUploadService } from '../../shared/core/file-upload.service';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../shared/services/auth.service';
import { User } from '../../shared/models/User';
import { UserFriendlyErrorService } from '../../shared/services/user-friendly-error.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss']
})
export class OrganizationComponent implements OnInit, AfterViewInit {
  user: User;
  @ViewChild('tooltip') tooltip: ElementRef;

  form: FormGroup;
  states: State[];
  counties: County[];
  orgCategories: OrgCategory[];
  districts: District[];
  regions: Region[];
  regionId = 0;
  regionName: string;
  headends: OrgHeadends[];
  busyDetails = false;
  busyVoiceRecorder = false;

  model: any = {
    orgName: null,
    countyId: null,
    state: null,
    categoryId: null,
    contact1State: null,
    contact2State: null,
    districtId: null,
    publicPrivateInd: null,
    regionId: null,
    headend: null
  };

  constructor(
    private stateService: StateService,
    private route: ActivatedRoute,
    private router: Router,
    private busyService: BusyService,
    private countyService: CountyService,
    private orgCategoryService: OrgCategoryService,
    private districtService: DistrictService,
    private regionService: RegionService,
    private headendService: HeadendService,
    private organizationService: OrganizationService,
    private alertService: AlertService,
    private fileUploadService: FileUploadService,
    private userFriendlyErrorService: UserFriendlyErrorService,
    private cd: ChangeDetectorRef
  ) {
    this.user = AuthService.currentUser();
    this.form = new FormGroup(
      {
        orgName: new FormControl('', [Validators.required]),
        orgStreet: new FormControl('', []),
        orgDisplayCity: new FormControl('', []),
        orgState: new FormControl('', [Validators.required]),
        orgZip: new FormControl('', []),
        orgZip4: new FormControl('', []),
        orgPhone: new FormControl('', []),
        orgFax: new FormControl('', []),
        orgCounty: new FormControl('', [Validators.required]),
        orgSchoolDistrict: new FormControl('', []),
        orgRegion: new FormControl('', []),
        orgHeadEnd: new FormControl('', []),
        orgWebAddress: new FormControl('', []),
        orgEmailAddress: new FormControl('', [nullableEmailValidator]),
        orgCategory: new FormControl('', [Validators.required]),
        orgPubPriv: new FormControl('', []),
        orgWebOnly: new FormControl('', []),

        cont1Name: new FormControl('', []),
        cont1Title: new FormControl('', []),
        cont1Email: new FormControl('', [nullableEmailValidator]),
        cont1Phone: new FormControl('', []),
        cont1Street: new FormControl('', []),
        cont1State: new FormControl('', []),
        cont1City: new FormControl('', []),
        cont1Zip: new FormControl('', []),

        cont2Name: new FormControl('', []),
        cont2Title: new FormControl('', []),
        cont2Email: new FormControl('', [nullableEmailValidator]),
        cont2Phone: new FormControl('', []),
        cont2Street: new FormControl('', []),
        cont2State: new FormControl('', []),
        cont2City: new FormControl('', []),
        cont2Zip: new FormControl('', []),

        orgId: new FormControl('', []),
        orgCurrPassword: new FormControl('', []),
        updated: new FormControl('', []),

        orgRetypePassword: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            numberValidator,
            Validators.minLength(4)
          ])
        ),
        orgPassword: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            numberValidator,
            Validators.minLength(4)
          ])
        )
      },
      matchingPasswords('orgPassword', 'orgRetypePassword')
    );

    this.busyService.initHandler('orgCmp', busy => {
      this.busyDetails = busy;
    });

    this.busyService.initHandler('orgCmpVoiceRecorder', busy => {
      this.busyVoiceRecorder = busy;
    });

    if (!this.user.isInRole(['superuser'])) {
      this.regionId = this.user.regionId;
    }

    if (!this.user.isInRole(['sysadmin', 'superuser'])) {
      this.form.controls.orgName.disable();
      this.form.controls.orgStreet.disable();
      this.form.controls.orgDisplayCity.disable();
      this.form.controls.orgState.disable();
      this.form.controls.orgZip.disable();
      this.form.controls.orgZip4.disable();
      this.form.controls.orgPhone.disable();
      this.form.controls.orgFax.disable();
      this.form.controls.orgCounty.disable();
      this.form.controls.orgSchoolDistrict.disable();
      this.form.controls.orgRegion.disable();
      this.form.controls.orgHeadEnd.disable();
      this.form.controls.orgWebAddress.disable();
      this.form.controls.orgEmailAddress.disable();
      this.form.controls.orgCategory.disable();
      this.form.controls.orgPubPriv.disable();
      this.form.controls.orgWebOnly.disable();
    }
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.route.params.subscribe(p => {
        if (p['orgId'] > 0) {
          this.busyService
            .follow('orgCmp', this.organizationService.get(p['orgId']))
            .subscribe(org => {
              this.model = org;
              this.model.zip = this.model.zip
                ? this.model.zip.toString().trim()
                : '';
              this.model.zip4 = this.model.zip4
                ? this.model.zip4.toString().trim()
                : '';
              this.model.webOnlyBool = org.webOnly === '0' ? false : true;
              this.model.currentPassword = this.model.password;
              this.model.password = '';
              this.model.retypePassword = '';

              this.form.controls['orgPassword'].setValidators(
                Validators.compose([numberValidator, Validators.minLength(4)])
              );

              this.form.controls['orgRetypePassword'].setValidators(
                Validators.compose([numberValidator, Validators.minLength(4)])
              );

              this.getCountyByState();
              this.getDistrictByCounty();
              this.getHeadendByRegion();
            });
        }
      });

      this.busyService
        .follow('orgCmp', this.orgCategoryService.all())
        .subscribe(categories => {
          this.orgCategories = categories;
        });

      this.busyService
        .follow('orgCmp', this.regionService.all())
        .subscribe(regions => {
          this.regions = regions;
          if (this.regionId > 0) {
            this.regionName = regions.filter(
              r => r.regionId === this.regionId
            )[0].regionName;
            this.model.regionId = this.regionId;
            this.getHeadendByRegion();
          }
        });

      this.busyService
        .follow('orgCmp', this.stateService.all())
        .subscribe(states => {
          this.states = states;
        });
    });
  }

  save() {
    if (!this.form.valid) {
      for (const c in this.form.controls) {
        if (!c) {
          continue;
        }
        const control = this.form.controls[c];
        control.markAsDirty();
      }
      return;
    }

    this.model.webOnly = !!this.model.webOnlyBool ? '1' : '0';

    this.busyService
      .follow('orgCmp', this.organizationService.save(this.model))
      .subscribe(res => {
        if (this.model.orgId) {
          this.alertService.showSuccess(
            'The organization was updated successfully.'
          );
        } else {
          this.alertService.showSuccess(
            'The organization was added successfully.'
          );
        }

        this.model.orgId = res.entity.orgId;
        this.model.currentPassword = res.entity.password;
        this.model.updateDate = res.entity.updateDate;

        this.router.navigateByUrl('orgedit/' + this.model.orgId);
      });
  }

  cancel() {
    this.router.navigateByUrl('list');
  }

  getCountyByState() {
    if (!this.model.state) {
      this.counties = [];
      this.model.countyId = null;
      return;
    }
    this.busyService
      .follow('orgCmp', this.countyService.getByState(this.model.state))
      .subscribe(counties => {
        this.counties = counties;
      });
  }

  getDistrictByCounty() {
    if (!this.model.countyId) {
      this.districts = [];
      this.model.districtId = null;
      return;
    }
    this.busyService
      .follow('orgCmp', this.districtService.getByCounty(this.model.countyId))
      .subscribe(districts => {
        this.districts = districts;
      });
  }

  getHeadendByRegion() {
    if (!this.model.regionId) {
      this.headends = [];
      this.model.headend = null;
      return;
    }
    this.busyService
      .follow('orgCmp', this.headendService.getByRegionId(this.model.regionId))
      .subscribe(headends => {
        this.headends = headends;
      });
  }

  getSoundUrl() {
    if (this.model.orgVox) {
      return (
        environment.api.baseUrl +
        environment.api.organizations.playSound
          .toString()
          .replace('{filename}', this.model.orgVox) +
        (this.model.orgVox.indexOf('?') > -1 ? '&' : '?') +
        'access_token=' +
        encodeURIComponent(this.user.token)
      );
    }
    return null;
  }

  onSendSound(sound) {
    const url =
      environment.api.baseUrl +
      environment.api.organizations.sendSound.replace(
        '{orgId}',
        this.model.orgId
      );

    if (sound.RecorderFlash) {
      console.log('flash');
      this.busyService.busy('orgCmpVoiceRecorder');
      sound.RecorderFlash.upload({
        method: 'POST',
        url:
          url +
          '?access_token=' +
          encodeURIComponent(AuthService.currentUser().token),
        success: response => {
          this.model.orgVox =
            JSON.parse(response).filename + '?t=' + Date.now();
          this.busyService.alive('orgCmpVoiceRecorder');
          this.cd.detectChanges();
        }
      });
    } else {
      const files = [];
      const audioFile = <any>new Blob([sound.blob], { type: 'audio/wav' });
      audioFile.name = this.model.orgId.toString() + '.wav';
      files.push(<File>audioFile);

      this.busyService.busy('orgCmpVoiceRecorder');

      this.fileUploadService
        .upload(url, files)
        .then(r => {
          console.log('html5-3');
          this.model.orgVox = r.filename + '?t=' + Date.now();
          this.busyService.alive('orgCmpVoiceRecorder');
        })
        .catch(error => {
          console.log('html5-4');
          this.alertService.showError(
            this.userFriendlyErrorService.getErrorMessage(url)
          );

          this.busyService.alive('orgCmpVoiceRecorder');
        });
    }
  }

  goModifyClosingStatus() {
    this.router.navigateByUrl('/orgstatus/' + this.model.orgId);
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/organization/organization.component.ts